<template>
  <div class="page">
    <LoadingSpinner v-if="processing" id="loading-spinner" />
    <div id="action-bar">
      <div class="horiz space">
        <select v-model="currentKit" @change="goToKit">
          <option :value="null" :disabled="true">Select kit...</option>
          <option v-for="kit in kits" :key="'kit-' + kit.id" :value="kit.id">{{
            kit.name
          }}</option>
        </select>
        <template v-if="kitId">
          <button @click="saveKit" class="primary">Save</button>
          <button @click="deleteKit" class="outline thin">
            <v-icon name="trash" />
          </button>
        </template>
      </div>
      <button @click="addKit" class="outline">Add kit</button>
    </div>

    <div v-if="editKit" id="kit-editor">
      <div>
        <h2>Information</h2>
        <base-input v-model="editKit.name" type="text" label="Name" />
        <base-input v-model.number="editKit.cost" type="number" label="Cost" />
        <base-input
          v-model="editKit.description"
          type="text"
          label="Description"
        />
        Last updated: {{ editKit.updated | date }}
      </div>
      <div>
        <h2>Bio markers</h2>
        <div
          v-for="(marker, index) in editKit.markers"
          :key="'marker-' + index"
          class="kit-marker"
        >
          <div>
            <div>
              <strong>{{ marker.title }}</strong> ({{ marker.id }})
            </div>
            <div>{{ marker.type }}, unit: {{ marker.unit }}</div>
          </div>
          <button @click="removeMarker(marker.id)" class="transparent">
            <v-icon name="trash" />
          </button>
        </div>
        <button class="outline" @click="addPanel('select-marker')">
          Add marker
        </button>
      </div>
    </div>
    <PanelSelectMarker
      @select="addMarker"
      :selectedMarkers="editKit ? editKit.markers : []"
    />
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner";
import PanelSelectMarker from "./PanelSelectMarker";
import { mapState } from "vuex";

export default {
  name: "AdminKits",
  data() {
    return {
      processing: false,
      currentKit: null,
      editKit: null
    };
  },
  props: {
    kitId: {
      type: String,
      required: false
    }
  },
  components: {
    LoadingSpinner,
    PanelSelectMarker
  },
  methods: {
    async addKit() {
      const kitName = prompt("Kit name");
      if (!kitName) return;
      this.processing = true;
      const id = await this.$store.dispatch("KitsStore/addKit", { kitName });
      this.processing = false;
      this.$router.push("/admin/kits/" + id);
      this.currentKit = id;
      this.getEditKit();
    },
    async deleteKit() {
      if (!confirm("Really delete?")) return;
      await this.$store.dispatch("KitsStore/deleteKit", { id: this.kitId });
      this.$router.push("/admin/kits").catch(err => {});
      this.editKit = null;
    },
    addMarker(obj) {
      // console.log(obj);
      this.editKit.markers.push(obj);
    },
    removeMarker(id) {
      this.editKit.markers.splice(
        this.editKit.markers.findIndex(marker => marker.id === id),
        1
      );
    },
    async saveKit() {
      this.processing = true;
      await this.$store.dispatch("KitsStore/saveKit", this.editKit);
      this.getEditKit();
      this.processing = false;
    },
    goToKit() {
      this.editKit = null;
      this.$router.push("/admin/kits/" + this.currentKit).catch(err => {});
      this.getEditKit();
    },
    async getEditKit() {
      if (this.currentKit) {
        this.editKit = await this.$store.dispatch(
          "KitsStore/getKitById",
          this.currentKit
        );
      } else {
        this.editKit = null;
      }
    }
  },
  computed: {
    ...mapState("KitsStore", ["kits"])
  },
  async mounted() {
    if (this.kitId) this.currentKit = this.kitId;

    this.processing = true;
    await this.$store.dispatch("KitsStore/kitsSubscribe");
    await this.getEditKit();
    this.processing = false;
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/vars";

#kit-editor {
  margin-top: @h2;
  padding: @h2;
  background-color: #eee;
  display: flex;
  flex-direction: row;
  h2 {
    margin-top: 0;
  }
  & > div {
    flex: 0 50%;
  }
  & > div + div {
    margin-left: @h2;
  }

  .kit-marker {
    padding: @hh;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: @hh;
    margin-bottom: @hh;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
